export default "__VITE_ASSET__CMMIWqES__"